import { Pipe, PipeTransform } from '@angular/core';
import * as moment from 'moment';
moment.locale('pt-BR');

@Pipe({
    name: 'pipeHoraBrasil'
})
export class PipeHoraBrasil implements PipeTransform {
    transform(date: string): string {
        return moment(date).format('DD/MM/YYYY HH:mm')
    }
}


// WEBPACK FOOTER //
// ./src/app/restricted/pipe/pipeHoraBrasil.ts